import React, { useState, useEffect } from "react";
import axios from "axios";
import { API, useAuth } from "@/App";
import { SiteHeader } from "@/components/site/SiteHeader";
import { SiteFooter } from "@/components/site/SiteFooter";
import { HeroSection, CategoryStrip, BrandRail, DealsGrid, HowItWorks, JoinBanner } from "@/components/home/HomeSections";

const HomePage = () => {
  const { user } = useAuth();
  const [data, setData] = useState({ categories: [], products: [], sliders: [], brands: [] });

  useEffect(() => {
    Promise.all([
      axios.get(`${API}/categories`),
      axios.get(`${API}/products/affiliate?limit=12`),
      axios.get(`${API}/sliders`),
      axios.get(`${API}/brands/all`),
    ])
      .then(([c, p, s, b]) =>
        setData({
          categories: c.data.categories || [],
          products: p.data.products || [],
          sliders: s.data.sliders || [],
          brands: b.data.brands || [],
        })
      )
      .catch((err) => console.error("Failed to fetch home data", err));
  }, []);

  return (
    <div className="min-h-screen bg-background" data-testid="home-page">
      <SiteHeader />
      <HeroSection user={user} slider={data.sliders[0]} />
      <CategoryStrip categories={data.categories} />
      <BrandRail brands={data.brands} />
      <DealsGrid products={data.products} />
      <HowItWorks />
      <JoinBanner user={user} />
      <SiteFooter />
    </div>
  );
};

export default HomePage;
